import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { GoogleFreeBookingLinksSettings } from "@/components/features-new/settings-external-connection/google-free-booking-links/settings";

import { useConfirmParams } from "./hooks";

export const SettingsExternalConnectionGoogleFreeBookingLinksPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta
			title="Google無料予約リンクの設定"
			url={generatePath(PATHS.SETTINGS.EXTERNAL_CONNECTION.GOOGLE_FREE_BOOKING_LINKS.DEFAULT, { hotelID })}
		>
			<GoogleFreeBookingLinksSettings hotelID={hotelID} />
		</PageMeta>
	);
};

SettingsExternalConnectionGoogleFreeBookingLinksPage.displayName =
	"SettingsExternalConnectionGoogleFreeBookingLinksPage";
